import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProductService } from 'src-adisco/services/product.service';
import { EntityService } from 'src/app/admin/core/services/entity.service';
import { Extranet } from 'src/app/shared/entities/extranet';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { Produit } from 'src-befor/produit';
import { CommonService } from 'src-adisco/services/common.service';
import { catchError, Subject, takeUntil } from 'rxjs';

import { filter, switchMap } from 'rxjs/operators'; // Import filter operator
interface UrlImage {
    nameFile: string;
    nameFileDetail: string;
    urlFile: string;
    imgURL?: string;
}
@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.css'],
})
export class ProductDetailComponent implements OnDestroy {
    ListDetail = {};
    idProduct!: any;
    dataDetailProduct: any;
    listIdAssociatedProduct = [];
    listIdDispenserForUseWithProduct = [];
    listIdDilutionProduct = [];

    champs: any;
    extranet: Extranet;
    product: Produit;
    categoryLogoUrl: string = '';
    isLoading: boolean = true;
    isLoadingCategoryLogo: boolean = true;
    categoriesLevelList: any[] = [];
    allCategoriesById: any = {};
    private destroy$: Subject<void> = new Subject<void>();
    listUrlImageProduct: UrlImage[] = [];

    // constructor(
    //   private dynamicDocumentService: DynamicDocumentService,
    //   private _activeRouter: ActivatedRoute,
    //   private router: Router,
    //   private entityService: EntityService,
    //   private activatedRoute: ActivatedRoute,
    //   private commonService: CommonService
    // ) {
    //   // Call API to get the product detail

    //   this.activatedRoute.params.subscribe((params) => {
    //     if (params['id']) {
    //       this.idProduct = params['id'];

    //       this.commonService.getAllCategories().pipe(takeUntil(this.destroy$)).subscribe((allCates: any) => {
    //         if (allCates) {
    //           this.allCategoriesById = { ...allCates };
    //           this.getDetailProduct();
    //         };
    //       })
    //     }
    //   });
    // }
    // ngOnDestroy(): void {
    //   this.destroy$.next();
    //   this.destroy$.complete();
    // }

    // ngOnInit() {
    //   this.getParamUrl();
    //   this.getChampsProduits();
    // }

    // getParamUrl(): void {
    //   this.idProduct = '' + this._activeRouter.snapshot.paramMap.get('id');
    // }

    // getDetailProduct() {
    //   this.isLoading = true;

    //   let filters = [
    //     {
    //       "fieldName": "uniqueId",
    //       "conditions": [
    //         {
    //           "type": "EQUALS",
    //           "value": this.idProduct
    //         }
    //       ]
    //     },
    //   ];

    //   this.dynamicDocumentService
    //     .find(
    //       {
    //         collectionName: 'dynamic_product',
    //         filters: filters,
    //         sorts: {
    //           publishedOrder: 'DESC'
    //         },
    //         page: 1,
    //         pageSize: 150,
    //       },
    //       true
    //     )
    //     .subscribe({
    //       next: (res) => {
    //         if (res?.content[0]) {
    //           this.assignProductData(res.content[0]);
    //         } else {
    //           this.dynamicDocumentService.findById('dynamic_product', this.idProduct).pipe(
    //             catchError((err) => {
    //               this.assignProductData({});
    //               return err;
    //             })
    //           ).subscribe((res) => {
    //             if (res) {
    //               this.assignProductData(res);
    //             }
    //             else {
    //               this.assignProductData({});
    //               this.isLoading = false;
    //             }
    //           })

    //         }
    //       },
    //       error: (_error) => {
    //         this.isLoading = false;
    //       },
    //     });
    // };

    // assignProductData(data: any) {
    //   this.dataDetailProduct = data;

    //   this.listIdAssociatedProduct = this.dataDetailProduct?.associatedProduct ?? [];
    //   this.listIdDispenserForUseWithProduct = this.dataDetailProduct?.distributor1Associated ?? [] // change dispenserForUseWithProduct to distributor1Associated;

    //   this.listIdDilutionProduct = this.dataDetailProduct?.dilutionSystem1 ?? [];

    //   this.dataDetailProduct?.categoryCode?.[0]?.value.split('.')[0] ? this.getLevel1Category(this.dataDetailProduct?.categoryCode[0].value.split('.')[0]) : (this.isLoadingCategoryLogo = false);
    //   this.getReplacementProductInfo(this.dataDetailProduct?.replacementProduct);
    //   const allLevel: any = {};
    //   this.summaryBreadcrumbs(this.dataDetailProduct?.categoryCode, allLevel);

    //   this.categoriesLevelList = Object.values(allLevel);
    // }

    constructor(
        private dynamicDocumentService: DynamicDocumentService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private commonService: CommonService,
        private entityService: EntityService
    ) {
        // Subscribe to route changes
        this.router.events
    .pipe(
        filter((event) => event instanceof NavigationEnd),
        switchMap(() => this.activatedRoute.params),
        takeUntil(this.destroy$)
    )
    .subscribe({
        next: (params) => {
            if (params['id']) {
                this.idProduct = params['id'];

                /* this.commonService
                    .getFlatCategories()
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (allCates: any) => {
                            if (allCates) {
                                this.allCategoriesById = { ...allCates };
                            }
                            this.getDetailProduct();
                        },
                        error: () => {
                            this.getDetailProduct();
                        }
                    }); */
            }
        },
       /*  error: () => {
            this.getDetailProduct();
        }, */
    });
    }


    ngOnInit() {
        this.getChampsProduits();
        this.fetchCategories()
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    fetchCategories(){
        this.dynamicDocumentService
        .getCategoryAllLevelStatusPublic([], 'linkToProduct')
        .subscribe((cats: any) => {
          cats.content.forEach((item: any) => {
            this.allCategoriesById[item.id] = item;
          });
          this.getDetailProduct()
        });
    };
    

    getDetailProduct() {
        this.isLoading = true;
        const filters = [
            {
                fieldName: 'uniqueId',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.idProduct,
                    },
                ],
            },
        ];

        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_product',
                    filters,
                    sorts: {
                        publishedOrder: 'DESC',
                    },
                    page: 1,
                    pageSize: 150,
                },
                true
            )
            .subscribe({
                next: (res) => {
                   
                    if (res?.content[0]) {
                        this.assignProductData(res.content[0]);
                    } else {
                        this.dynamicDocumentService
                            .findById('dynamic_product', this.idProduct)
                            .pipe(
                                catchError((err) => {
                                    this.assignProductData({});
                                    return err;
                                })
                            )
                            .subscribe((res) => {
                                if (res) {
                                    this.assignProductData(res);
                                } else {
                                    this.assignProductData({});
                                }
                            });
                    }
                    if (this.dataDetailProduct?.linkToResources) {
                        // Use Set to avoid duplicate document IDs
                        let IdResources = new Set<any>();

                        // Loop through linkToResources and add documentId to the Set
                        this.dataDetailProduct.linkToResources.forEach((resource: any) => {
                            IdResources.add(resource.documentId);
                        });

                        // Convert Set back to an array and call getListUrlFile if there are any resources
                        const uniqueIdResources = Array.from(IdResources);

                        if (uniqueIdResources.length > 0) {
                            this.getListUrlFile(uniqueIdResources);
                        }
                    }
                },
                error: (_error) => {
                    this.isLoading = false;
                },
            });
    }
    assignProductData(data: any) {
        this.dataDetailProduct = data;
        this.listIdAssociatedProduct = this.dataDetailProduct?.associatedProduct ?? [];
        this.listIdDispenserForUseWithProduct =
            this.dataDetailProduct?.distributor1Associated ?? [];
        this.listIdDilutionProduct = this.dataDetailProduct?.dilutionSystem1 ?? [];

        if (this.dataDetailProduct?.categoryCode?.[0]?.value.split('.')[0]) {
            this.getLevel1Category(this.dataDetailProduct?.categoryCode[0].value.split('.')[0]);
        } else {
            this.isLoadingCategoryLogo = false;
        }

        this.getReplacementProductInfo(this.dataDetailProduct?.replacementProduct);
        const allLevel: any = {};
        this.summaryBreadcrumbs(this.dataDetailProduct?.categoryCode, allLevel);
        this.categoriesLevelList = Object.values(allLevel);
    }
    summaryBreadcrumbs(categoryCodeArr: any[], allLevel: any, parent?: string) {
        if (categoryCodeArr?.length) {
            categoryCodeArr.forEach((cate: any) => {
                const findCate = this.allCategoriesById[cate?.id ?? cate?.documentId];

                if (findCate && findCate?.categoryLevelCategory) {
                    if (!Array.isArray(allLevel[findCate.categoryLevelCategory]))
                        allLevel[findCate.categoryLevelCategory] = [];
                    if (
                        !allLevel[findCate.categoryLevelCategory].find(
                            (item: any) => item.id === findCate.id
                        )
                    )
                        allLevel[findCate.categoryLevelCategory].push(findCate);

                    if (
                        Array.isArray(findCate?.attachmentCategory) &&
                        findCate.attachmentCategory.length
                    ) {
                        this.summaryBreadcrumbs(findCate.attachmentCategory, allLevel);
                    }
                }

                // this.categoriesLevelList.push({ nameCategory: res.content[0]?.nameCategory['fr_FR'], codeCategory: res.content[0]?.codeCategory });
            });
        }
    }

    getReplacementProductInfo(replacementProduct: any) {
        if (!replacementProduct?.documentId || !replacementProduct?.documentName) {
            this.isLoading = false;
            return;
        }

        this.dynamicDocumentService
            .findById(replacementProduct.documentName, replacementProduct.documentId)
            .pipe(
                catchError((err) => {
                    // not found
                    this.dataDetailProduct.replacementProduct = null;
                    this.isLoading = false;
                    return err;
                })
            )
            .subscribe((product) => {
                if (product) {
                    product?.uniqueId &&
                        (this.dataDetailProduct.replacementProduct = {
                            ...this.dataDetailProduct.replacementProduct,
                            uniqueId: product?.uniqueId,
                        });
                } else {
                    // not found
                    this.dataDetailProduct.replacementProduct = null;
                }

                this.isLoading = false;
            });
    }

    getLevel1Category(codeCategory: any) {
        let filterCategories = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
            {
                fieldName: 'codeCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: codeCategory,
                    },
                ],
            },
        ];
        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_category',
                    filters: filterCategories,
                    sorts: {},
                    page: 1,
                    pageSize: 1,
                },
                true
            )
            .pipe(
                catchError((err) => {
                    this.isLoadingCategoryLogo = false;
                    return err;
                })
            )
            .subscribe((res: any) => {
                this.categoryLogoUrl = res.content[0]?.pictoOfTheCategory[0]?.url;
                this.isLoadingCategoryLogo = false;
            });
    }

    async getChampsProduits() {
        try {
            const entite = 'dynamic_product';
            const res = await this.entityService.getDynamicDocumentFields(entite);
            this.champs = res;
            this.entityService.setReqMap(entite, res);
        } catch (error) {
            console.error('Error getting product entity fields:', error);
        }
    }

    getListUrlFile(ids: any[]): void {
        this.dynamicDocumentService
            .findByIds('dynamic_ressource', ids, true)
            .subscribe((res: any) => {
                const dataListImage = res;
                const matchingItemsPhoto = dataListImage?.filter((item: any) => {
                    return (
                        item.typeOfResource &&
                        (item.typeOfResource.value === 'FT' ||
                            item.typeOfResource.value === 'FDS' ||
                            item.typeOfResource.value === 'CERTIF') &&
                        item.file?.length > 0
                    );
                });
                matchingItemsPhoto.forEach((item: any) => {
                    const urlFile = item?.file[0]?.url;

                    if (urlFile) {
                        const imageRegex =
                            /\.(jpg|jpeg|png|gif|bmp|tiff|webp|svg|heif|heic|jfif|ico)(\?.*)?$/i;
                        const imgURL = imageRegex.test(urlFile) ? urlFile : '';
                        this.listUrlImageProduct.push({
                            nameFile: item?.typeOfResource?.labels?.fr_FR ?? 'Pièce jointe',
                            nameFileDetail: item?.title,
                            urlFile: item?.file[0]?.url,
                            imgURL: imgURL,
                        });
                    }
                });
            });
    }
    // getListUrlFile(id: any): void {
    //   this.dynamicDocumentService
    //     .find({
    //       "collectionName": "dynamic_ressource",
    //       "filters": [
    //         {
    //           "fieldName": "linkToProduct",
    //           "conditions": [
    //             {
    //               "type": "EQUALS",
    //               "value": id
    //             }
    //           ]
    //         }
    //       ],
    //       "sorts": {},
    //       "page": 1,
    //       "pageSize": 20
    //     })
    //     .subscribe((res: any) => {
    //       const dataListImage = res.content;
    //       const matchingItemsPhoto = dataListImage.filter((item: any) => {
    //         return item.typeOfResource
    //           && (item.typeOfResource.value === "FT" || item.typeOfResource.value === "FDS" || item.typeOfResource.value === "CERTIF")
    //           && item.file?.length > 0;
    //       });
    //       matchingItemsPhoto.forEach((item: any) => {
    //         const urlFile = item?.file[0]?.url;

    //         if (urlFile) {
    //           const imageRegex = /\.(jpg|jpeg|png|gif|bmp|tiff|webp|svg|heif|heic|jfif|ico)(\?.*)?$/i;
    //           const imgURL = imageRegex.test(urlFile) ? urlFile : '';
    //           this.listUrlImageProduct.push({
    //             nameFile: 'Pièce jointe',
    //             nameFileDetail: item?.title,
    //             urlFile: item?.file[0]?.url,
    //             imgURL: imgURL
    //           });

    //         }
    //       });
    //     });
    // }
}
